export default __webpack_public_path__ + "static/media/4.1b6dbcbd.png";